module.exports = __webpack_public_path__ + "assets/img/69_725_4.cf8c1fb0.jpg";